import React from 'react';
import { motion } from 'framer-motion';
import { Github, Twitter, Linkedin } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-100 py-10 mt-auto">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-bold leading-tight">Export Readiness Test</h3>
<h5 className="text-sm font-medium text-gray-500 leading-none -mt-0 mb-4">
  powered by Lagos School of Export Management
</h5>
            <p className="text-sm text-gray-600 mt-2 mb-4">
              A comprehensive assessment tool to evaluate your business's preparedness for international export markets.
            </p>
            <div className="flex space-x-4">
              <motion.a 
                href="#" 
                whileHover={{ y: -3 }}
                whileTap={{ scale: 0.95 }}
                className="text-gray-600 hover:text-primary-600 transition-colors"
              >
                <Github size={20} />
              </motion.a>
              <motion.a 
                href="#" 
                whileHover={{ y: -3 }}
                whileTap={{ scale: 0.95 }}
                className="text-gray-600 hover:text-primary-600 transition-colors"
              >
                <Twitter size={20} />
              </motion.a>
              <motion.a 
                href="#" 
                whileHover={{ y: -3 }}
                whileTap={{ scale: 0.95 }}
                className="text-gray-600 hover:text-primary-600 transition-colors"
              >
                <Linkedin size={20} />
              </motion.a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-primary-600 transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-primary-600 transition-colors">
                  Export Resources
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-primary-600 transition-colors">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-primary-600 transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Export Resources</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://www.lsem.org.ng/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-primary-600 transition-colors"
                >
                  Lagos School of Export Management
                </a>
              </li>
              <li>
                <a 
                  href="https://www.nepc.gov.ng/"
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-primary-600 transition-colors"
                >
                  Nigeria Export Promotion Council
                </a>
              </li>
              <li>
                <a 
                  href="https://www.neximbank.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-primary-600 transition-colors"
                >
                  Nigeria Export Import Bank
                </a>
              </li>
              <li>
                <a 
                  href="https://edc.lsem.org.ng/"
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-primary-600 transition-colors"
                >
                  Export Development Centre
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500 text-center">
            © {currentYear} Lagos School of Export Management. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;